import { autocompleteClasses } from '@mui/material/Autocomplete';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
export var createMuiAutocompleteOverrides = function (_a) {
    var _b, _c;
    var spacing = _a.spacing, typography = _a.typography;
    return {
        styleOverrides: {
            inputRoot: (_b = {
                    minHeight: 40
                },
                // https://github.com/mui-org/material-ui/blob/master/packages/material-ui-lab/src/Autocomplete/Autocomplete.js#L79
                _b["&[class*=\"".concat(outlinedInputClasses.root, "\"]")] = (_c = {
                        padding: spacing(0.25, 1, 0.25, 0.5)
                    },
                    _c["& .".concat(autocompleteClasses.input)] = {
                        padding: spacing(0.5, 1),
                        '&:first-child': {
                            paddingLeft: spacing(1.75),
                        },
                    },
                    _c["& .".concat(autocompleteClasses.endAdornment)] = {
                        right: spacing(0.75),
                    },
                    _c),
                _b),
            tag: {
                margin: 1,
            },
            endAdornment: {
                top: 'unset',
            },
            option: {
                lineHeight: 2,
                fontSize: typography.pxToRem(14),
                '&:not(:last-child)': {
                    borderBottom: 'none',
                },
            },
        },
    };
};
